import React from 'react';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { BulletList } from 'web-ui-components/lib/typography/lists';

const AboutYourApplicationPage = ({ saveApplicationCompleteForm, getBusinessData }) => {
  return (
    <Form
      onSubmit={saveApplicationCompleteForm}
      initialValues={getBusinessData}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({
              aboutYourApplicationEligibleContent1,
              aboutYourApplicationEligibleContent2,
              aboutYourApplicationEligibleContent3,
              needToTitle,
              personalDetailsText,
              whatsHappenedListItem1,
              whatsHappenedListItem2,
              yourApplicationTitle,
              eligibilityTitle,
              personalDetailSubItemText,
              businessDetailSubItemText,
              financialDetailSubItemText,
              aboutYourApplicationText
            }) => (
              <div>
                <StandardBody>
                  <PageHeading>{yourApplicationTitle}</PageHeading>
                  <SubHeading>{eligibilityTitle}</SubHeading>
                  <BulletList
                    items={[
                      aboutYourApplicationEligibleContent1,
                      aboutYourApplicationEligibleContent2,
                      aboutYourApplicationEligibleContent3
                    ]}
                  />
                  <SectionHeading>{needToTitle}</SectionHeading>
                  <BulletList
                    items={[
                      personalDetailsText,
                      [personalDetailSubItemText],
                      whatsHappenedListItem1,
                      [businessDetailSubItemText],
                      whatsHappenedListItem2,
                      [financialDetailSubItemText]
                    ]}
                  />
                </StandardBody>
                <Submit />
              </div>
            )}
          </Content>
        </form>
      )}
    />
  );
};
AboutYourApplicationPage.propTypes = {
  saveApplicationCompleteForm: PropTypes.func.isRequired
};

export default AboutYourApplicationPage;
